<template>
  <div id="modal">

    <v-dialog
      class="dialog-l"
      min-height="400px"
      persistent
      v-model="dialog"
    >
      <v-card flat>
        <v-card-text class="pt-1 pa-3">
          <div v-if="!edit" style="margin: 20px 0">{{value.createTimestamp | getDay }}</div>
          <h1 class="black--text" v-if="!edit" style="margin-top: 13px">{{value.name}}</h1>

          <v-textarea
            solo
            readonly
            class="main--text mt-2"
            v-model="value.desc"
            row="4"
            v-if="!edit && value.desc !== ''"
            flat
          ></v-textarea>

          <!-- no description-->
          <v-textarea
            solo
            readonly
            class="main--text mt-2"
            v-if="!edit && value.desc === ''"
            v-model="desc"
            flat
          ></v-textarea>
         
          <span>
            <a
              v-if="!edit"
              :href="https + value.website"
              target="_blank"
              style="font-size: 1.1rem !important"
            >
            {{value.website}}
            </a>
          </span>

        <!-- edit mode -->
          <div class="mt-4">
            <v-text-field
            v-if="edit"
            @keyup.enter.native="saveEdit(value.name, value.desc, value.website, value.uuid)"
            label="Task Name"
             required
            v-model="value.name"
            color="black"
            class="main--text"
            placeholder=" "
          ></v-text-field>
        

          <v-textarea
            v-if="edit"
            name="input-7-1"
            label="Description"
             color="black"
            class="main--text"
            :rules="[rules.length(200)]"
            counter="200"
            v-model="value.desc"
            placeholder=" "
          ></v-textarea>

          <v-text-field
            @keyup.enter.native="saveEdit(value.name, value.desc, value.website, value.uuid)"
            label="Website"
            v-if="edit"
            v-model="value.website"
            color="black"
            class="main--text"
            placeholder=" "
          ></v-text-field>
          </div>
        </v-card-text>

        <v-card-actions>
           <v-bottom-navigation grow style="box-shadow: none; height: 42px;">
          <v-btn color="black" text v-if="!edit" @click="sendMail(value)">
            <v-icon color="black">mdi-email</v-icon>
          </v-btn>

          <v-btn text v-if="!edit && !deleteyes" @click="deleteyes = true">
            <v-icon color="black">mdi-delete</v-icon>
          </v-btn>

          <transition name="slide-x-transition">
            <v-btn text v-if="deleteyes && !edit" @click="deleteCardsEnd(value.uuid)">
             YES?
              <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path fill="#000000" d="M17 4V6H3V4H6.5L7.5 3H12.5L13.5 4H17M4 19V7H16V19C16 20.1 15.1 21 14 21H6C4.9 21 4 20.1 4 19M19 16H21V18H19V16M19 9H21V14H19V9Z" />
              </svg>
            </v-btn>
          </transition>

          <v-btn text v-if="!edit" @click="edit = true">
            <v-icon color="black">mdi-pencil</v-icon>
          </v-btn>

          <div style="display: flex; justify-content: center">
          <v-btn text class="grey btn-roundy" v-if="edit" @click="edit = false">
            <span class="black--text">close</span>
          </v-btn>
          <v-btn class="btn-roundy main" text @click="saveEdit(value.name, value.desc, value.website, value.uuid)" v-if="edit">
            <span class="black--text">Save</span>
          </v-btn>
          </div>

          <v-btn @click="$emit('close')" v-if="!edit"  text>
            <span
              title="Close"
              class="black--text"
              style="font-size: 20px"
            >X</span>
          </v-btn>
           </v-bottom-navigation>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import lSmallModal from "@/components/smallModal";
import { getDay } from "@/filters";
import { mapState, mapActions } from "vuex";
import { database, firestore } from "@/firebase/async-firestore";
import firebase from "firebase/app";

export default {
  components: {
    lSmallModal
  },
  props: ["value", "isProductDeletionPending", "disableActions"],
  data() {
    return {
      deleteyes: false,
      edit: false,
      texty: "",
      exists: false,
      https: "https://",
      text: "Delete card and create space?",
      deleteCard: false,
      desc: 'No description',
      dialog: true,
      navbar: true,
      rules: {
        length: len => v => (v || '').length <= len || `Invalid character length, max. length ${len}`,
      },
    };
  },
  computed: {
    ...mapState("user", ["currentUser", "userProfile"]),
  },
  methods: {
    ...mapActions("posts", ["deleteUserProduct"]),
    deleteCardsEnd(data) {
      this.deleteUserProduct(data);
    },
    deleteCards() {
      this.deleteCard = true;
    },
    sendMail(event) {
      if(event.link !== '') {
        window.location = `mailto:${this.currentUser.email}?subject=${event.name}&body=${event.desc},%20${event.link}`;
      } else {
        window.location = `mailto:${this.currentUser.email}?subject=${event.name}&body=${event.desc}`;
      }
    },
    async isSending(event) {
      let docId = this.userProfile.general.userId;
      let friendsData = {
        name: this.userProfile.name,
        userId: docId,
        image: this.userProfile.general.image,
        currentUserId: docId
      };
      const selectedContent = friendsData;
      const randomUserId = docId;

      this.$store
        .dispatch("random/triggerUpdateFriendsAction", {
          selectedContent,
          randomUserId
        })
        .then(async () => {
          (await database())
            .ref("notify/" + this.userProfile.general.userId + "/" + event.name)
            .once("value", snapshot => {
              if (snapshot.exists()) {
                const userData = snapshot.val();
                this.exists = userData;
              }
            });
        })
        .then(async () => {
          if (!this.exists) {
            setTimeout(async () => {
              (await database())
                .ref(
                  "notify/" + this.userProfile.general.userId + "/" + event.name
                )
                .set(true)
                .catch(err => {
                  console.log(err);
                });
            }, 1000);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    saveEdit(name, desc, website, uuid) {
      // this.edit = false;
      var selectedContent = {
        name,
        desc,
        website
      };
      const path = "name";
      const path2 = "desc";
      const path3 = "website";
      this.$store.dispatch("posts/triggerUpdateProductAction", {
        selectedContent,
        path,
        path2,
        path3,
        uuid
      });
    }
  }
};
</script>

<style>
.btn-roundy {
  border-radius: 4px !important;
  font-size: 0.9rem !important;
}
.v-text-field.v-text-field--enclosed .v-text-field__details, .v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
  padding: 0 !important;
}
#modal .theme--light.v-label {
    color: #000 !important;
}

#modal .theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
  color: #000 !important;
}

#modal .theme--light.v-counter {
    color: #000;
}


#modal .theme--light.v-input:not(.v-input--is-disabled) input,
#modal .theme--light.v-input:not(.v-input--is-disabled) textarea {
    color: #000 !important;
}

.v-dialog {
  width: 90% !important;
}

@media screen and (min-width: 800px) {
  .v-dialog {
    width: 70.4% !important;
  }
}

@media screen and (min-width: 1000px) {
  .v-dialog {
    width: 43.4% !important;
  }
}
</style>